export class RSA {
  /***
   * Encrypts a plaintext message with the given public key
   * @param key A crypto.subtle CipherKey object (see: createKeyFromBuffer)
   * @param message Plaintext message
   */
  public static async encryptMessage(key, message) {
    const cipher = await window.crypto.subtle.encrypt(
      {
        name: 'RSA-OAEP',
      },
      key,
      Buffer.from(message).buffer,
    );

    return Buffer.from(cipher).toString('base64');
  }

  /***
   * Create a crypto.subtle CipherKey object for encryption
   * @param publicKey Public key buffer (DER formatted)
   */
  public static async createKeyFromBuffer(publicKey: Buffer) {
    return await window.crypto.subtle.importKey(
      'spki',
      publicKey,
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256',
      },
      true,
      ['encrypt'],
    );
  }
}
